export const TIRE_PROMO = 'tires'
export const SERVICES_PROMO = 'services'
export const FINANCING_PROMO = 'specialFinancing'
export const OTHER_PROMO = 'others'
export const REBATE_PROMO = 'rebate'

export const PROMO_TYPES = {
  [TIRE_PROMO]: 'tire-promo',
  [SERVICES_PROMO]: 'service-red',
  [FINANCING_PROMO]: 'card-promo',
  [OTHER_PROMO]: 'tire-promo',
  [REBATE_PROMO]: 'money-promo'
}

